<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1"> {{ $t("view_qr") }}</v-tab>

            <v-tab> {{ $t("preview") }}</v-tab>
            <v-tab :disabled="e6 <= 1" :ripple="true"> تعرفه‌ها </v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                
                </v-btn>
              </div>
            </v-tab-item>

            <v-tab-item>
              <view-luck-wheel
                v-model="cardTexts"
                :id="createdId || 'preview-mode'"
                :qr-svg-data-url="qrSvgDataUrl"
              />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'wheel'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-12">
                  <p>{{ $t("create_qr") }}</p>
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 2"
                    :error-messages="errors.title"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام گردونه شانس شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :help-data="helpData"
                    :label="$t('luck_wheel_name')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 2"
                    :error-messages="errors.identifier"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :help-data="helpData"
                    :label="$t('qr_address')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(false)"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >وارد کردن اطلاعات</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <v-card-actions class="justify-space-between mb-4">
                <div>
                  <div class="d-flex row mx-0 mt-2">
                    <v-btn
                      :disabled="e6 > 2"
                      color="third"
                      outlined
                      @click="clearDefaults"
                    >
                      <v-icon class="me-2">mdi-delete</v-icon>
                      {{ $t("buttons.cleardefaults") }}
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-clearDefaults`"
                      :help-data="helpData"
                      :label="$t('buttons.cleardefaults')"
                      :service-name="serviceName"
                    />
                  </div>
                </div>
              </v-card-actions>
                    <div class="mb-4">
                            <!-- سوییچ و آیکون راهنما -->
                            <div class="d-flex align-center">
                              <v-switch
                                v-model="AutoSave"
                                color="primary"
                                class="mt-0 pt-0 shrink"
                                hide-details
                                label="ذخیره خودکار"
                              ></v-switch>

                              <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                              <v-tooltip bottom max-width="320">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    x-small
                                    class="mr-1"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.stop
                                  >
                                    <v-icon small color="grey darken-1">
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                                </span>
                              </v-tooltip>
                            </div>

                            <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                            <div
                              v-if="$vuetify.breakpoint.xsOnly"
                              class="text-caption grey--text text--darken-1 mt-1 pr-1"
                              style="line-height: 1.4"
                            >
                              تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                            </div>
                          </div>


              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <next-btn :loading="loading" @click="qrUpdate(true)" />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download_qr') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :help-data="helpData"
              :label="$t('download_qr')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </template>
          <v-card class="pa-5">
            <div class="rowinfo">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                class="contentinfo"
                @close="showDialog = false"
                :qr_id="info.qrId"

              />
              <help-info
                :element-name="`${serviceName}-${componentName}-cardTexts-visitName`"
                :help-data="helpData"
                :label="$t('download')"
                :service-name="serviceName"
                class="buttoninfo"
              />
            </div>
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake";
import { mapActions, mapState } from "vuex";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import ViewLuckWheel from "@/view/pages/otherQrTypes/luckWheel/cm/viewLuckWheel.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "CreateLuckWheel",

  components: {
    ViewLuckWheel,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    DownloadFileWithApi,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    Tariffs,
    AtomSpinner
  },

  data: () => ({
    isAutoSaving: false, 
    AutoSave:false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "luck-wheel-create",
    createdDomain: null,
    createdId: null,
    domainId: null,
    dtUrl: null,
    errors: {},
    e6: 1,
    info: null,
    showDialog: false,
    loading: false,
    qrShow: 1,
    qrDesign: {},
    qrSvgDataUrl: "",
    cardTexts: {
      visitName: "",
      info: {
        logo: "",
        name: "",
        subtitle: "",
        background_color: "#FFFFFFFF",
        user_limit: 0,
        qr_id: "",
      },
      prizes: {
        id: null,
        items: [],
      },
      login: {
        requireLogin: false,
        image: "",
      },
    },
  }),

  mounted() {
    this.$root.$on("setWheelId", this.setWheelId);

    this.$i18n.locale = getLanguageCookie() || "fa";
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    specialInfo() {
      return [
        {
          name: "luckWheelInfo",
          value: "",
          title: "اطلاعات",
          subtitle: "",
          icon: "information-variant-circle-outline",
          model: "info",
        },
        {
          name: "luckWheelManagement",
          value: "",
          title: "مدیریت شانس",
          subtitle: "",
          icon: "account-outline",
          model: "prizes",
        },
        {
          name: "luckWheelLogin",
          value: "",
          title: "مدیریت ثبت نام",
          subtitle: "",
          icon: "login-variant",
          model: "login",
        },
      ];
    },
  },

  watch: {
    cardTexts: {
      handler(newVal) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true,
      immediate: true,
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;

      let obj = {
        type: "wheel",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.errors = {};
      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.qrShow = 0;
          this.createdId = data.data.identifier;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.setCreatedQrID(data.data.id);
          this.updateQrId(data.data.id);
          this.updateQridentifier(data.data.identifier);
          this.setQrType(data.data.type);
          this.updateQrDomain(this.createdDomain);

          this.$toast.success("کیوآر گردونه شانس شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2; // رفتن به مرحله بعد
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
                this.qrShow = 1;
              }, 2000);
            });
          }
           else if (final) this.goto("qr/list");
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "wheel");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if(final || !this.AutoSave)
            this.$toast.success("کیوآر گردونه شانس شما با موفقیت ویرایش شد.");
          if (this.e6 === 2 && final) {
            this.e6++;
            setTimeout(() => {
              this.$refs.qrCanvas.appendCanvas(this.info.link);
            }, 500);
            // setTimeout(() => {
            //   this.qrUpdate(false);
            //   this.qrShow = 1;
            // });
            if(final)
              this.goto("qr/list");
          }
        })
        .catch((err) => {
          this.$toast.error(this.$t("create_menu.error_saving_updating_qr"));
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      let name = this.cardTexts.visitName;
      this.cardTexts = {};
      this.cardTexts.visitName = name;
    },
    setWheelId(id) {
      this.cardTexts.prizes.id = id;
    },
  },

  beforeDestroy() {
    this.setCreatedQrID(null);
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
